export default "__VITE_ASSET__J1UQvX63__";